import { render, staticRenderFns } from "./newCreateNode.vue?vue&type=template&id=61527436&scoped=true&"
import script from "./newCreateNode.vue?vue&type=script&lang=js&"
export * from "./newCreateNode.vue?vue&type=script&lang=js&"
import style0 from "./newCreateNode.vue?vue&type=style&index=0&id=61527436&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61527436",
  null
  
)

export default component.exports